<script setup lang="ts">
  defineProps<{
    required?: boolean;
    label?: string;
    name?: string;
    showError?: boolean;
  }>();
</script>

<template>
  <UFormField
    :ui="{ label: 'text-white', error: showError ? '' : 'hidden' }"
    :required="required"
    :label="label"
    :name="name"
  >
    <template #label>
      <slot name="label"></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
  </UFormField>
</template>
